import {MakeModelFaqsRequestError} from './MakeModelFaqsRequestError.js'
import {SeoDataRequestError} from './SeoDataRequestError.js'
import {SeoMakeModelFaqsError} from './SeoMakeModelFaqsError.js'
import {SeoMakeModelFaqsNotFoundError} from './SeoMakeModelFaqsNotFoundError.js'

export class SeoErrorsFactory {
  static seoDataRequestError = msg => new SeoDataRequestError(msg)

  static seoMakeModelFaqsError = msg => new SeoMakeModelFaqsError(msg)

  static makeModelFaqsRequestError = msg => new MakeModelFaqsRequestError(msg)

  static seoMakeModelFaqsNotFoundError = msg => new SeoMakeModelFaqsNotFoundError(msg)
}
